import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { navigationUrl } from '../../../store/analytic/actions';
import Modal from '../index';

import { Content } from './styles';

interface ISend {
  handlerClose: () => void;
}

function SendWhatsapp({ handlerClose }: ISend) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      navigationUrl.request({
        action: '/contatoWhatsApp',
      })
    );
  }, [dispatch]);

  return (
    <Modal
      title={'Contato por Whatsapp'}
      handlerClose={handlerClose}
      width={
        window.matchMedia('(max-width: 960px)').matches ? '360px' : '464px'
      }
    >
      <Content>
        <div>Oi</div>
      </Content>
    </Modal>
  );
}

export default SendWhatsapp;
